<template>
  <div>

    <div v-if="showCreatenewPassword == false" class="container" style="margin-top: 5%">
      <div class="columns" style="height: 600px">

        <div class="column">
          <div class="box ml-5" style="width: 150%; height: 100%">
            <img :src="require('@/assets/gifs/enter-otp.gif')" alt="signup-gif" style="height: 550px;" align="left">
          </div>
        </div>

        <div class="column">
          <div class="box-1" style="height: 105%; margin-top: -2%">
            <div style="width: 90%; height: 500px; padding: 10px">
              <p class="signIn is-size-1">Enter OTP Code</p>
<!--              <p style="color: #8C8C9B"  v-if="$root.agentContactNumber">We have sent an OTP to <b>{{ ContactNumber }}</b><br>Please check your contact number and enter OTP code below</p>-->
              <p style="color: #8C8C9B" >We have sent an OTP to <b>{{Email}}</b><br>Please check your e-mail and enter OTP code below</p>
              <div style="margin-top: 15%">
                <b-field
                    :type="invalidOtp == '' ? 'is-info' : 'is-danger'"
                    :message="invalidOtp"
                    style="text-align: left"
                    label="OTP Code"
                    :label-position="labelPosition"
                >
                  <b-input
                      v-model="InputOTP"
                      maxlength="6"
                      rounded
                      @keydown.native="RestrictInputOnlyNumbers" @input="resetInvalidStatus('invalidOtp')"
                  ></b-input>
                </b-field>
              </div>


              <div class="columns">
                <div class="column">
                  <p style="text-align: left" v-if="visible">Didn't Receive? <a style="font-weight: bold" @click="resendOTP">Click Here</a></p>
                </div>
                <div class="column">
                  <p style="text-align: right" v-if="!visible">Resend OTP in <span style="color:#0D5DA3; font-weight: bold " >{{countDown}}</span></p>
                </div>
              </div>

              <div style="margin-top: 10%">
                <div class="buttons">
                  <b-button type="is-info" outlined rounded expanded @click="validateAndSubmit">Confirm</b-button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <!--create new password-->
    <create-new-pwd v-if="showCreatenewPassword" :userid="user_id"></create-new-pwd>
  </div>



</template>

<script>


import createNewPwd from "@/views/backend/CreateNewPwd";
import axios from "axios";

export default {
  name:"otpcode-view",

  props:['otpcode','action','userid'],

  components:{
    createNewPwd
  },

  mounted() {

    this.visible = false
    this.countDown = 30
    this.timerCount()
    if(this.$root.agentEmail){
      this.hideemail()
    }else if(this.$root.agentContactNumber){
      this.ContactNumber =this.hideContactNumber()

    }


  },

  data(){
    return{
      labelPosition: "on-border",
      otp:this.otpcode,
      resendOtp:'',
      InputOTP:'',
      invalidOtp:'',
      countDown:'',
      visible:'',
      showCreatenewPassword:false,
      Email:'',
      ContactNumber:'',
      regex: {
        otp: /^[0-9]{6}$/,
      },

      user_id:'',

    }
  },

  methods:{
    validateForm: function(){
      var formIsValid = true

      // otpcode
      if(this.InputOTP =='' || this.InputOTP.indexOf(' ') >= 0){
        this.invalidOtp = 'This field cannot left blank'
        formIsValid = false
      }



      if(formIsValid){
        return true
      }
      else{
        return false
      }

    },

    hideemail:function() {
      var email = this.$root.agentEmail
      var hiddenEmail = "";
      for (var i = 0; i < email.length; i++) {
        if (i > 2 && i< email.indexOf("@") ) {
          hiddenEmail += "x";
        } else {
          hiddenEmail += email[i];
        }
      }
      this.Email = hiddenEmail
    },

    // hideContactNumber:function() {
    //   var contact = this.$root.agentContactNumber
    //   const endDigits = contact.slice(-4);
    //   return endDigits.padStart(contact.length, '*');
    // },



    matchOTP:function ()
    {
      var component = this
      if(component.InputOTP == component.otp)
      {
        if(component.action == 'password-reset'){
          component.showCreatenewPassword =true
          component.user_id = component.userid
        }else{
          component.$router.push({name:'agentDashboard'})

        }



      }else{
        component.$buefy.toast.open({
          message: 'Account verification failed - Invalid OTP Code',
          type: 'is-danger'
        })
      }
    },

    validateAndSubmit: function(){
      if(this.validateForm()){
        this.matchOTP()
      }
      else{
        this.formIsInvalid = true
      }
    },


    timerCount: function () {
      if(this.countDown != 0){
        setTimeout(() => {
          this.countDown -= 1
          this.timerCount();
        }, 1000)
      }else{
        this.countDown = 30
        this.visible =true
      }

    },

    RestrictInputOnlyNumbers: function(event){
      switch (event.keyCode) {
        case 8:  // Backspace
        case 9:  // Tab
        case 13: // Enter
        case 37: // Left
        case 38: // Up
        case 39: // Right
        case 40: // Down
          break;
        default:
          var regex = new RegExp("^[0-9]+$");
          var key = event.key;
          if (!regex.test(key)) {
            event.preventDefault();
            return false;
          }
          break;
      }
    },

    resetInvalidStatus: function(key){

      this[key] = ''
      this.formIsInvalid = false


    },

    resendOTP:function () {
      var comp = this

      if (comp.action == 'password-reset') { //forgot psw otp resend
        comp.visible = false
        comp.timerCount()

        axios.post(comp.$base_url + '/agent/forgetpassword', {
          email: comp.$root.agentEmail,
          contact: comp.$root.agentContactNumber
        })
            .then(function (data) {
              var array = []
              array = data.data

              if (array.success == false) {
                comp.$buefy.toast.open({
                  message: 'Failed to send OTP code',
                  type: 'is-danger'
                })
              } else {
                comp.otp = array.data.otp
              }

            })
            .catch(function (error) {
              console.log(error)
            });

      } else {  // sign in otp re-send
        comp.visible = false
        var email = comp.$root.agentEmail
        var contact = comp.$root.agentContactNumber
        var agentname = comp.$root.agentName
        comp.timerCount()

        axios.post(comp.$base_url + '/agent/resendotp/' + email + '/' + contact + '/' + agentname, {
          auth_token: comp.$root.agentAuthToken,

        })
            .then(function (data) {
              console.log(data, "data")
              comp.otp = data.data
              if (!data) {
                comp.$buefy.toast.open({
                  message: 'Failed to send OTP code',
                  type: 'is-danger'
                })
              }

              comp.otp = data.data
              console.log(data.data);

            })
            .catch(function (error) {
              console.log(error)
            });

      }

    }
  },




}
</script>

<style scoped>
@media only screen and (max-width: 600px) {
  .box{
    display: none;
  }

}

.signIn {
  padding-top: 30px;
  font-weight: bold;
  background: -webkit-linear-gradient(#3a8fff 0 30%, #0837ae 55% 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

p {
  color: gray;
  font-weight: 500;
}
.link {
  color: #0d5da3;
  text-decoration: underline;
  cursor: pointer;
}
.link:hover {
  color: #092bc2;
  text-shadow: 1px;
}

.box-1 {
  position: relative;
  z-index: 1;
  background-color: white;
  border-radius: 0 15px 15px 0;
  box-shadow: 0 -5px 5px -5px #333, 5px 0 5px -5px #333, 0 5px 5px -5px #333;
}
.box-1::before {
  position: absolute;
  left: -5%;
  content: "";
  width: 70px;
  z-index: -1;
  height: 100%;
  background-color: inherit;
  border-radius: 15px 0 0 15px;
  box-shadow: 0 -1px 5px -5px #333, -5px 0 5px -5px #333, 1px 5px 0px -5px #333;
  /* box-shadow: 0px 10px 0px 0 rgb(41, 33, 33); */
  transform: skew(-5deg);
}
</style>
